import React, { useState } from 'react';

/**
 * Mark a line item LOST (sales rework Phase 5). Lost is a status with a
 * MANDATORY categorised reason — the stage stays where it was.
 */

export const LOST_REASONS = [
  { value: 'price', label: 'Price' },
  { value: 'competitor', label: 'Went to a competitor' },
  { value: 'no_budget', label: 'No budget' },
  { value: 'timing', label: 'Timing' },
  { value: 'no_decision', label: 'No decision' }
];

function MarkLostModal({ item, authFetch, onClose, onDone }) {
  const [reason, setReason] = useState('');
  const [competitor, setCompetitor] = useState('');
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const save = async () => {
    if (!reason) {
      setError('A lost reason is required');
      return;
    }
    setSaving(true);
    setError('');
    try {
      const response = await authFetch(`/api/v1/opportunities/${item.opportunity_id}/lose`, {
        method: 'POST',
        body: JSON.stringify({
          reason,
          competitor: competitor.trim() || null,
          note: note.trim() || null
        })
      });
      if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        throw new Error(body.message || 'Failed to mark line item lost');
      }
      onDone();
    } catch (err) {
      setError(err.message);
      setSaving(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Mark {item.opp_ref} Lost</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          {error && <div className="form-error">{error}</div>}
          <div className="form-group">
            <label>Reason *</label>
            <select value={reason} onChange={(e) => setReason(e.target.value)}>
              <option value="">Select…</option>
              {LOST_REASONS.map(option => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
          </div>
          {reason === 'competitor' && (
            <div className="form-group">
              <label>Competitor</label>
              <input value={competitor} onChange={(e) => setCompetitor(e.target.value)} />
            </div>
          )}
          <div className="form-group">
            <label>Note (optional)</label>
            <textarea rows={2} value={note} onChange={(e) => setNote(e.target.value)} />
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose} disabled={saving}>Back</button>
          <button className="btn-danger" onClick={save} disabled={saving}>
            {saving ? 'Saving…' : 'Mark Lost'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default MarkLostModal;
